module.exports = __webpack_public_path__ + "img/1.5_Russian_road_sign.90f1a139.svg";